import MiniSearch from 'minisearch';
const search_show_length = 25;
var minisearch = null;
var latest_search_results = null;
var last_shown_result = 0;

function display_search_status(message) {
    document.getElementById("search-system-status").innerHTML = message;
}

async function load_search_index() {
    let fetched_index = await fetch("/assets/json/search-index.json");
    let index = await fetched_index.json();
    return index;
}

async function create_minisearch() {
    display_search_status("Initializing search system...");
    minisearch = new MiniSearch({ 
        idField: 'relative_url',
        fields: ['title', 'creator', 'tags', 'description', 'type'],
        storeFields: ['title', 'creator', 'tags', 'thumbnail', 'relative_url', 'type', 'description']
    });
    display_search_status("Loading search index...");
    var search_index = await load_search_index();
    display_search_status("Parsing search index...");
    await minisearch.addAllAsync(search_index);
    display_search_status("Search fully loaded!");
    setTimeout(display_search_status, 2000, "");
}

function create_array_of_results(search_results, from = 0, to = search_results.length) {
    let array_of_elements = [];
    
    for (let result of search_results.slice(from, to)) {
        console.log(result);
        let result_div = document.createElement("a");
        result_div.classList.add("result");
        result_div.classList.add(result.type);
        result_div.href = result.relative_url;

        result_div.innerHTML = `<img src="${result.thumbnail}"><div><h1>${result.title}</h1><h2>${result.description}</h2></div>`;
        array_of_elements.push(result_div);
    }

    if (array_of_elements === undefined || array_of_elements == 0) {
        let element_search_empty = document.createElement("p");
        element_search_empty.innerHTML = "No results found!";
        array_of_elements.push(element_search_empty);
    }

    return array_of_elements;
}

function search_by_term(term_to_search) {
    let dom_elements = [];

    if (term_to_search.length < 2) {
        let no_way = document.createElement("p");
        no_way.innerHTML = "I refuse to let you search for such a general thing. It's a bad idea, believe me. You will not do it."
        dom_elements.push(no_way);
    }
    else {
        latest_search_results = minisearch.search(term_to_search);

        if (!document.cookie.includes("allow-nsfw=true")) {
            // USER DID NOT ALLOW PORNOGRAPHY. ACTIVATE CATHOLICISM!
            latest_search_results = latest_search_results.filter(result => {
                return !result.tags.includes("nsfw");
            });
        }

        dom_elements = create_array_of_results(latest_search_results, 0, search_show_length);
        last_shown_result = search_show_length;
    }


    document.getElementById("search-results").replaceChildren(...dom_elements);
    search_check_for_see_more_button();
}

function run_test_search() {
    let search_text = document.getElementById("search-text").value;
    search_by_term(search_text);
}

function search_check_for_see_more_button() {
    if (last_shown_result < latest_search_results.length - 1) {
        let show_more = document.createElement("a");
        show_more.classList.add("result");
        show_more.classList.add("show-more");
        show_more.href = "javascript:void(0);";
        show_more.onclick = function() {
            search_show_more(this);  
        }
        

        show_more.innerHTML = `<h1>Show More!</h1>`;

        document.getElementById("search-results").append(show_more);
    }
}


function search_show_more(button) {
    button.remove(); // Remove the See More! button.

    let dom_elements = create_array_of_results(latest_search_results, last_shown_result, last_shown_result + search_show_length);
    last_shown_result += search_show_length;
    document.getElementById("search-results").append(...dom_elements);

    search_check_for_see_more_button();
}

// Give window permission to use the relevant functions.
Object.assign(window, {
    create_minisearch,
    run_test_search,
    search_show_more
});